import axios from 'axios'
import Swal from 'sweetalert2'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`
const SUGARCOACH_BASE_URL = `${process.env.REACT_APP_BACKEND_HOST}`

const axiosInstance = axios.create()

//요청 가로채기
axiosInstance.interceptors.request.use(
  //요청 보내기전 수행
  async function (config) {
    const recoilValue = localStorage.getItem('recoil-persist')
    if (recoilValue !== null) {
      const parserdRecoilValue = JSON.parse(recoilValue)
      if (
        parserdRecoilValue !== null &&
        parserdRecoilValue?.token?.accessToken &&
        parserdRecoilValue?.token?.refreshToken
      ) {
        // config.headers['x-dy-accesstoken'] =
        //   parserdRecoilValue.token.accessToken
        // config.headers['x-dy-refreshToken'] =
        //   parserdRecoilValue.token.refreshToken
      }
    }
    return config
  },
  //오류 요청
  function (err) {
    // 서버에서 에러 응답이 온 경우
    if (err.response) {
      const status = err.response.status

      if (status >= 400 && status < 500) {
        Swal.fire({
          icon: 'error',
          title: '에러 발생',
          text: err.response.data.detail.description,
        })
      } else if (status >= 500 && status < 600) {
        Swal.fire({
          icon: 'error',
          title: '서버 오류',
          text: '서버에 문제가 발생했습니다. 잠시 후 다시 시도해주세요.',
        })
      }
    }
    return Promise.reject(err)
  },
)

axiosInstance.interceptors.response.use(
  function (response) {
    return response
  },
  function (err) {
    if (err.response) {
      const status = err.response.status

      if (status >= 400 && status < 500) {
        Swal.fire({
          icon: 'error',
          title: '에러 발생',
          text: err.response.data.detail[1].description,
        })
      } else if (status >= 500 && status < 600) {
        Swal.fire({
          icon: 'error',
          title: '서버 오류',
          text: '서버에 문제가 발생했습니다. 잠시 후 다시 시도해주세요.',
        })
      }
    }
    return Promise.reject(err)
  },
)

/**
 * 팀 이름을 기반으로 유저 그룹 정보 조회
 * @param {Object} params - { teamName: string } 형식의 객체
 */
export const getUserGroupByTeam = async (params) => {
  const res = await axiosInstance.get(
    `${baseUrl}/salus-user/user-group-by-team`,
    {
      params: params, // 컨트롤러의 @RequestParam String teamName과 매칭됩니다.
    },
  )
  return res
}

export const getWorkList = async (params) => {
  const res = await axiosInstance.get(`${baseUrl}/salus-work/list`, {
    params: params,
  })
  return res
}

export const createEpic = async (params) => {
  const res = await axiosInstance.post(`${baseUrl}/salus-work/epic`, params)
  return res
}

export const createStory = async (params) => {
  const res = await axiosInstance.post(`${baseUrl}/salus-work/story`, params)
  return res
}

export const createTask = async (params) => {
  const res = await axiosInstance.post(`${baseUrl}/salus-work/task`, params)
  return res
}

export const updateEpic = async (params) => {
  const res = await axiosInstance.put(`${baseUrl}/salus-work/epic`, params)
  return res
}

export const updateStory = async (params) => {
  const res = await axiosInstance.put(`${baseUrl}/salus-work/story`, params)
  return res
}

export const updateTask = async (params) => {
  const res = await axiosInstance.put(`${baseUrl}/salus-work/task`, params)
  return res
}

export const getWorkDetail = async (params) => {
  const res = await axiosInstance.get(`${baseUrl}/salus-work/detail`, {
    params: params,
  })
  return res
}

export const getParentWorkItems = async (params) => {
  const res = await axiosInstance.get(
    `${baseUrl}/salus-work/list/parent-epic`,
    {
      params: params,
    },
  )
  return res
}

export const getGroupByTeam = async (params) => {
  const res = await axiosInstance.get(
    `${baseUrl}/salus-user/user-group-by-team`,
    {
      params: params,
    },
  )
  return res
}

export const getTaskOwnables = async (params) => {
  const res = await axiosInstance.get(
    `${baseUrl}/salus-work/list/task-ownables`,
    {
      params: params,
    },
  )
  return res
}

export const deleteEpic = async (params) => {
  const res = await axiosInstance.delete(`${baseUrl}/salus-work/epic`, params)
  return res
}

export const deleteStory = async (params) => {
  const res = await axiosInstance.delete(`${baseUrl}/salus-work/story`, params)
  return res
}

export const deleteTask = async (params) => {
  const res = await axiosInstance.delete(`${baseUrl}/salus-work/task`, params)
  return res
}

// 1. POST는 @RequestBody를 사용하므로 데이터를 그대로 전달합니다.
export const createTaskCheckList = (data) => {
  return axios.post(`${baseUrl}/salus-work/task/check-list`, data)
}

// 2. DELETE는 @RequestParam을 사용하므로 params 객체에 담아 전달합니다.
export const deleteTaskCheckList = (checkListId) => {
  return axios.delete(`${baseUrl}/salus-work/task/check-list`, {
    params: { checkListId }, // ?checkListId=... 형태로 전송됨
  })
}

// 3. PUT(Switch) 역시 @RequestParam이므로 두 번째 인자(body)는 null로 둡니다.
export const switchTaskCheckList = (checkListId) => {
  return axios.put(`${baseUrl}/salus-work/task/check-list/switch-check`, null, {
    params: { checkListId },
  })
}

// 4. PUT(Title)은 파라미터가 2개입니다.
export const updateTaskCheckListTitle = (checkListId, title) => {
  return axios.put(`${baseUrl}/salus-work/task/check-list/title`, null, {
    params: { checkListId, title },
  })
}

// FastLane 체크리스트 API
// 1. POST는 @RequestBody를 사용하므로 데이터를 그대로 전달합니다.
export const createFastlaneCheckList = (data) => {
  return axios.post(`${baseUrl}/salus-work/fastlane/check-list`, data)
}

// 2. DELETE는 @RequestParam을 사용하므로 params 객체에 담아 전달합니다.
export const deleteFastlaneCheckList = (checkListId) => {
  return axios.delete(`${baseUrl}/salus-work/fastlane/check-list`, {
    params: { checkListId }, // ?checkListId=... 형태로 전송됨
  })
}

// 3. PUT(Switch) 역시 @RequestParam이므로 두 번째 인자(body)는 null로 둡니다.
export const switchFastlaneCheckList = (checkListId) => {
  return axios.put(
    `${baseUrl}/salus-work/fastlane/check-list/switch-check`,
    null,
    {
      params: { checkListId },
    },
  )
}

// 4. PUT(Title)은 파라미터가 2개입니다.
export const updateFastlaneCheckListTitle = (checkListId, title) => {
  return axios.put(`${baseUrl}/salus-work/fastlane/check-list/title`, null, {
    params: { checkListId, title },
  })
}

export const getTodayTasks = async (salusUserId) => {
  const res = await axios.get(
    `${baseUrl}/salus-work/list/task/today-check-list`,
    {
      params: { salusUserId },
    },
  )
  // console.log('getTodayTasks res = ', res)
  return res
}

export const getUserTeam = async (salusUserId) => {
  const res = await axios.get(`${baseUrl}/salus-work/team/${salusUserId}`)
  return res
}

export const getUserRole = async (salusUserId) => {
  const res = await axios.get(`${baseUrl}/salus-user/role/${salusUserId}`)
  return res.data
}

export const getProgressState = async (workId) => {
  const res = await axios.get(`${baseUrl}/salus-work/progress-state/${workId}`)
  return res
}

export const getAgileBoard = async (studioGroupId, salusUserId) => {
  // console.log('getAgileBoard studioGroupId = ', studioGroupId)
  const res = await axios.get(
    `${baseUrl}/salus-agile/dashboard/studio/${studioGroupId}`,
    {
      params: { salusUserId },
    },
  )
  // console.log('getAgileBoard res = ', res)
  return res
}

export const getChildTasks = async (storyWorkId) => {
  const res = await axios.get(`${baseUrl}/salus-work/list/${storyWorkId}`)
  return res.data
}
export const getTeamGroups = async () => {
  const res = await axios.get(`${baseUrl}/salus-user/teams`)
  return res?.data
}

/**
 * 스튜디오별 팀 목록 조회
 * @param {number} studioGroupId
 * @returns {Promise<Array<{ id: number, name: string, nameKo?: string }>>}
 */
export const getTeamsByStudio = async (studioGroupId) => {
  const res = await axios.get(
    `${baseUrl}/salus-user/studios/${studioGroupId}/teams`,
  )
  return res?.data
}

/**
 * 스튜디오명 또는 스튜디오 ID로 스튜디오 정보 + 소속 팀 목록 조회
 * @param {{ studioName?: string, studioGroupId?: number }}
 * @returns {Promise<{ studioGroupId: number, studio: string, studioKo?: string, teams: [] }>}
 */
export const getUserGroupByStudio = async (params) => {
  const res = await axios.get(`${baseUrl}/salus-user/user-group-by-studio`, {
    params,
  })
  return res?.data
}

// 팀 그룹 별 유저 목록 조회
export const getTeamUsers = async (teamGroupId) => {
  const res = await axios.get(`${baseUrl}/salus-user/team/${teamGroupId}/users`)
  return res?.data
}
